// Importing the StatusUpdate type for type safety when handling status updates
import type { StatusUpdate } from '../../../types';

// Defining the props interface for the StatusUpdatesSection component
interface StatusUpdatesSectionProps {
  // An array of status updates to be displayed
  updates: StatusUpdate[];
}
// Functional component to display recent status updates
function StatusUpdatesSection({ updates }: StatusUpdatesSectionProps) {
  return (
  <section className="mb-16">
    {/* Section heading */}
    <h2 className="text-3xl font-bold text-gray-900 mb-6 tracking-tight">
      Recent Updates
    </h2>

    {updates.length ? (
      <div className="space-y-4">
        {updates.map((update) => (
          <div
            key={update.id}
            className="bg-white p-5 rounded-xl shadow-sm transition hover:shadow-md hover:bg-gray-50"
          >
            <p className="text-gray-800 font-medium">
              <strong>{update.username}</strong>: {update.content}
            </p>
            <p className="text-gray-500 text-sm mt-1">
              {new Date(update.created_at).toLocaleString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
              })}
            </p>
          </div>
        ))}
      </div>
    ) : (
      <div className="bg-white p-6 rounded-xl shadow-sm text-center">
        <p className="text-gray-500">No recent updates.</p>
      </div>
    )}
  </section>
);


}
export default StatusUpdatesSection;